import { Box, styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        padding-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    `,
    Content: styled(Box)`
        width: 70%;
        gap: 24px;
        display: flex;
        flex-direction: column;
        ${props => props.theme.breakpoints.down("md")} {
            width: 80%;
        }
        ${props => props.theme.breakpoints.down("sm")} {
            width: 90%;
        }
        ${props => props.theme.breakpoints.down("xs")} {
            width: 95%;
        }
    `,
    Contact: styled(Box)`
        background-color: ${props => props.theme.palette.secondary.dark};
        border: 1px solid ${props => props.theme.palette.secondary.main};
        border-radius: 16px;
        padding: 12px 32px;

        & .MuiTypography-root {
            display: flex;
            align-items: center;
            font-family: Figtree;
            font-size: 14px;
            font-style: normal;
        }

        ${props => props.theme.breakpoints.down("sm")} {
            padding: 12px;

            & .MuiTypography-root {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 5px;

                & .MuiTypography-root {
                    display: flex;
                    flex-direction: row;
                    gap: 0;
                }
            }
        }
    `,
    Accordion: styled("div")`
        background-color: ${props => props.theme.palette.secondary.dark};
        border: 1px solid ${props => props.theme.palette.secondary.main};
        border-radius: 16px;
        padding: 32px 24px;
        display: flex;
        flex-direction: column;
        gap: 6px;

        & .MuiPaper-root {
            margin-top: 0;
            background: ${props => props.theme.palette.secondary.main};
            border: transparent;
            border-radius: 12px;

            & .MuiButtonBase-root {
                border-radius: 12px;

                padding: 0 24px;
                background-color: ${props => props.theme.palette.secondary.main};

                &:hover {
                    background: transparent;
                }
            }

            & .MuiList-root {
            }

            &:before {
                display: none;
            }

            &:first-of-type,
            &:last-of-type {
                border-radius: 12px;
            }
        }

        & .MuiAccordionSummary-content {
            font-family: Figtree;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;

            &:hover {
                background: none;
            }
        }

        & .MuiTypography-root {
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            font-family: Ubuntu;
        }

        & .MuiListItem-root {
            font-family: Ubuntu;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
        }

        & .heading {
            text-decoration: underline;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
        }

        & .title {
            padding-bottom: 16px;
            font-family: Figtree;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
        }
    `,
};
